import { CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Link } from 'react-router-dom';

import { PlusIcon } from 'assets/v2/icons';
import { newLayout } from 'theme';

import { StyledButton } from './SecondaryButton.styles';

const SecondaryButton = ({
  children,
  showIcon = false,
  loading = false,
  disabled = false,
  icon,
  size = 'medium',
  ...props
}) => {
  const buttonProps = {
    variant: 'contained',
    size,
    color: 'primary',
    disabled: disabled || loading,
    ...(showIcon && { startIcon: icon ?? <PlusIcon className="smallIcon" /> }),
    ...(props.to && {
      component: Link,
    }),
    ...props,
  };

  return (
    <StyledButton {...buttonProps}>
      {loading ? (
        <>
          <CircularProgress
            size={16}
            color="inherit"
            style={{ marginRight: newLayout.spacing.s2 }}
          />
          {children}
        </>
      ) : (
        children
      )}
    </StyledButton>
  );
};

SecondaryButton.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  to: PropTypes.object,
  showIcon: PropTypes.bool,
  icon: PropTypes.node,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default memo(SecondaryButton);
